<template>
  <div class="brakeDetail">
    <div class="part part1">
      <div class="title">库存信息</div>
      <div class="p1-cont">货 主：{{goods.supplier_name}}</div>
      <div class="p1-cont">货品名：{{goods.name}}</div>
      <div class="p1-cont" v-if="goods.bale == 1">
        库存量：
        <span :class="Number(goods.last_total_num)<0?'red':''">{{goods.last_total_num *1}}</span>
        {{unit_list[goods.num_unit-1].name}}
        (
        <span
          :class="Number(goods.last_total)<0?'red':''"
        >{{goods.last_total *1}}</span>公斤)
      </div>
      <div class="p1-cont" v-if="goods.bale == 2">
        库存量：
        <span :class="Number(goods.last_total_num)<0?'red':''">{{goods.lase_num *1}}</span>
        {{unit_list[goods.num_unit-1].name}}
        (
        <span
          :class="Number(goods.last_total)<0?'red':''"
        >{{goods.last_total *1}}</span>公斤)
      </div>
      <div class="p1-cont" v-if="goods.bale == 3">
        库存量：
        <span :class="Number(goods.last_total)<0?'red':''">{{goods.last_total *1}}</span>公斤
      </div>
      <div
        class="p1-cont"
        v-if="goods.bale==1"
      >销售量：{{goods.xs_total_num || 0}}{{unit_list[goods.num_unit-1].name}}</div>
      <div
        class="p1-cont"
        v-if="goods.bale==2"
      >销售量：{{goods.xs_num || 0}}{{unit_list[goods.num_unit-1].name}}</div>
      <div class="p1-cont" v-if="goods.bale==3">销售量：{{goods.xs_total || 0}}公斤</div>
      <div class="p1-date">创建时间：{{goods.create_time | toTime}}</div>
    </div>
    <div class="part part2">
      <div class="title">报损动态</div>
      <van-steps direction="vertical" :active="-1" active-color="#31B158" v-if="brakeList.length>0">
        <van-step v-for="(item,index) in brakeList" :key="index">
          <div class="p2-state">
            <div>报损人：{{item.user_realname}}</div>
            <div v-if="goods.bale==2 || goods.bale==3">报损量：{{item.num*1}}公斤</div>
            <div v-if="goods.bale==2 || goods.bale==1">
              报损定装数：{{item.number?item.number:0}}
              <span v-if="goods.bale!==3 && goods.num_unit==1">件</span>
              <span v-if="goods.bale!==3 && goods.num_unit==2">包</span>
              <span v-if="goods.bale!==3 && goods.num_unit==3">袋</span>
              <span v-if="goods.bale!==3 && goods.num_unit==4">盒</span>
              <span v-if="goods.bale!==3 && goods.num_unit==5">瓶</span>
              <span v-if="goods.bale!==3 && goods.num_unit==6">箱</span>
              <span v-if="goods.bale!==3 && goods.num_unit==7">罐</span>
            </div>
            <!-- <div>报损金额：{{item.money}}元</div> -->
            <!-- <div>库  存：{{item.user_realname}}</div> -->
            <div>{{item.create_time | toTime}}</div>
            <!-- <div @click="deleteBrake(item.id)">删除</div> -->
          </div>
        </van-step>
      </van-steps>
      <div v-else style="line-height:1rem;color:#999">暂无</div>
    </div>
    <div class="bottom" @click="toAddBrake()">报 损</div>
  </div>
</template>

<script>
import { timestampToTime } from "@/utils/timestamp";
import {
  damaged_batch,
  damaged_add,
  damaged_del
} from "@/api/work/manage/stock";
export default {
  name: "brakeDetail",
  data() {
    return {
      listQuery: {
        page: "1",
        pageSize: "15",
        batch: ""
      },
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      goods: {},
      brakeList: [],
      VNK: ""
    };
  },
  filters: {
    toTime(t) {
      return timestampToTime(t);
    }
  },
  created() {
    this.listQuery.batch = this.$route.query.batch;
    this.VNK = this.$route.query.VNK;
    this.getData();
    this.$navigation.on("back", (to, from) => {
      if (to.route.name == "manage_stock_brakeDetail") {
        if (from.route.name == "manage_stock_addBrake") {
          if (this.VNK == this.$route.query.VNK) {
            this.getData();
          }
        }
      }
    });
  },
  mounted() {},
  methods: {
    // 获取数据
    getData() {
      let obj = Object.assign({}, this.listQuery);
      damaged_batch(obj).then(res => {
        if (res.code == 200) {
          this.goods = res.data.list.goods;
          this.goods.supplier_name = this.goods.supplier.name;
          this.brakeList = res.data.list.goods.damaged || [];
        }
      });
    },
    // 去添加报损
    toAddBrake() {
      this.$router.push({
        path: "/manage/stock/addBrake",
        query: {
          batch: this.listQuery.batch,
          bale: this.goods.bale,
          num_unit: this.goods.num_unit
        }
      });
    },
    // 删除该报损记录
    deleteBrake(id) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除该条记录吗?"
        })
        .then(() => {
          damaged_del({ id }).then(res => {
            if (res.code == 200) {
              this.$toast.success(res.message);
              this.getData();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style lang="less" scoped>
.brakeDetail {
  padding-bottom: 1rem;
  .part {
    background-color: #fff;
    margin-top: 0.2rem;
    padding: 0.1rem 0.3rem;
    color: #333333;
    .title {
      font-size: 0.36rem;
      line-height: 0.75rem;
      border-bottom: 0.01rem solid #e5e5e5;
    }
    .title::before {
      content: "";
      display: inline-block;
      background-color: #31b158;
      width: 0.06rem;
      height: 0.33rem;
      margin-right: 0.1rem;
      // vertical-align: middle;
    }
  }
  .part1 {
    .title {
      margin-bottom: 0.1rem;
    }
    .p1-cont {
      font-size: 0.32rem;
      line-height: 0.51rem;
    }
    .p1-date {
      font-size: 0.28rem;
      color: #9a9a9a;
      line-height: 0.47rem;
    }
  }
  .part2 {
    .p2-state {
      > div {
        line-height: 0.47rem;
      }
    }
  }
  .bottom {
    width: 100%;
    background-color: #31b158;
    line-height: 1rem;
    text-align: center;
    color: #fff;
    font-size: 0.36rem;
    position: fixed;
    bottom: 0;
  }
  .red {
    color: #f00;
  }
}
</style>